import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5A36] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#0A1E40] text-white shadow-md hover:bg-[#0A1E40]/90 hover:shadow-lg active:scale-[0.98]",
        destructive:
          "bg-red-600 text-white shadow-md hover:bg-red-700 active:scale-[0.98]",
        outline:
          "border-2 border-[#D1CBBF] bg-white text-[#0A1E40] shadow-sm hover:bg-[#F5F0E6] hover:border-[#0A1E40]/30 active:scale-[0.98]",
        secondary:
          "bg-[#F5F0E6] text-[#0A1E40] shadow-sm hover:bg-[#E5DFD3] active:scale-[0.98]",
        ghost: "text-[#0A1E40] hover:bg-[#F5F0E6]",
        link: "text-[#FF5A36] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-11 px-5 py-2",
        sm: "h-9 rounded-lg px-4 text-xs",
        lg: "h-12 rounded-xl px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
